import { get as t } from "@ngard/tiny-get";
import r from "dset";
var i = function (t, r, i) {
    return void 0 === r && (r = 16), void 0 === i && (i = "rem"), "" + parseFloat(t) / r + i;
  },
  e = function (t, r) {
    return void 0 === r && (r = 16), parseFloat(t) * r + "px";
  },
  o = function (t) {
    return t.trim().match(/[\d.\-+]*\s*(.*)/)[1] || "";
  },
  s = function (t) {
    return "design-system-utils: Values missing at: " + t + " within your design tokens config";
  },
  n = function (t, r, i) {
    return "design-system-utils: There is a missing value at this key: " + t + "." + (void 0 === i ? r : r + "." + i);
  },
  p = function (t, r) {
    this.opts = Object.assign({}, {
      fontSizeUnit: void 0
    }, r), this.ds = t;
  };
p.prototype.get = function (r, i) {
  return void 0 === i && (i = this.ds), t(i, r, void 0);
}, p.prototype.set = function (t, i) {
  return r(this.ds, t, i);
}, p.prototype.fontSize = function (t) {
  var r;
  this.parentCheck("type.sizes"), "string" == typeof this.ds.type.baseFontSize && (r = parseFloat(this.ds.type.baseFontSize));
  var s = this.get(t, this.ds.type.sizes);
  if (void 0 === s) throw new Error(n("type.sizes", t));
  if (o(s) === this.opts.fontSizeUnit) return s;
  switch (this.opts.fontSizeUnit) {
    case "rem":
      return i(s, r, "rem");
    case "em":
      return i(s, r, "em");
    case "px":
      return e(s, r);
    default:
      return s;
  }
}, p.prototype.fs = function (t) {
  return this.fontSize(t);
}, p.prototype.spacing = function (t) {
  this.parentCheck("spacing.scale");
  var r = this.get("" + t, this.ds.spacing.scale);
  if (void 0 === r) throw new Error(n("spacing.scale", t));
  return "string" == typeof r ? r : r + "px";
}, p.prototype.space = function (t) {
  return this.spacing(t);
}, p.prototype.color = function (t, r) {
  void 0 === r && (r = "base");
  var i = "colors.colorPalette";
  if (void 0 === this.get("colors", this.ds) && void 0 === this.get(i, this.ds)) throw new Error(s(i));
  var e = t.split(".").length > 1 ? this.get(t, this.ds.colors.colorPalette) : this.ds.colors.colorPalette[t][r];
  if (void 0 === e) throw new Error(n(i, t, r));
  return e;
}, p.prototype.brand = function (t) {
  this.parentCheck("colors.brand");
  var r = this.get(t, this.ds.colors.brand);
  if (void 0 === r) throw new Error(n("colors.brand", t));
  return r;
}, p.prototype.bp = function (t) {
  if (void 0 === this.get("breakpoints", this.ds)) throw new Error(s("breakpoints"));
  var r = this.get(t, this.ds.breakpoints);
  if (void 0 === r) throw new Error(n("breakpoints", t));
  return r;
}, p.prototype.z = function (t) {
  if (void 0 === this.get("zIndex", this.ds)) throw new Error(s("zIndex"));
  var r = this.get(t, this.ds.zIndex);
  if (void 0 === r) throw new Error(n("zIndex", t));
  return r;
}, p.prototype.multiply = function (t, r) {
  return ("string" == typeof t ? parseFloat(this.get(t)) : t) * r;
}, p.prototype.parentCheck = function (t) {
  var r = t.split(".");
  if (void 0 === this.get(r[0], this.ds) && void 0 === this.get(t, this.ds)) throw new Error(s(t));
};
export default p;
export { i as pxTo, e as toPx, o as parseUnit };